import { render, staticRenderFns } from "./rpterctstdnotconfirmbyco.vue?vue&type=template&id=48822966&"
import script from "./rpterctstdnotconfirmbyco.vue?vue&type=script&lang=js&"
export * from "./rpterctstdnotconfirmbyco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports